import React from 'react';
import { DSButtonV2 } from '@elliemae/ds-button';
import { DSSeparator } from '@elliemae/ds-separator';
import { ScenarioFooterContainer, ButtonGroup } from './styled';

export interface ScenarioFooterProps {
  onCancel: () => void;
  onNext?: () => void;
  cancelLabel?: string;
  nextLabel?: string;
  isNextDisabled?: boolean;
}

export const ScenarioFooter: React.FC<ScenarioFooterProps> = ({
  onCancel,
  onNext,
  cancelLabel = 'Cancel',
  nextLabel = 'Next',
  isNextDisabled = false,
}) => {
  return (
    <ScenarioFooterContainer>
      <DSSeparator
        margin="none"
        orientation="horizontal"
        position="initial"
        type="non-form"
      />
      <ButtonGroup>
        <DSButtonV2
          buttonType="outline"
          size="m"
          onClick={onCancel}
          data-testid="scenario-footer-cancel"
        >
          {cancelLabel}
        </DSButtonV2>
        {onNext && (
          <DSButtonV2
            buttonType="filled"
            size="m"
            onClick={onNext}
            disabled={isNextDisabled}
            data-testid="scenario-footer-next"
          >
            {nextLabel}
          </DSButtonV2>
        )}
      </ButtonGroup>
    </ScenarioFooterContainer>
  );
};

export default ScenarioFooter;
